import React from "react";
import { View, Dimensions } from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../../utility/AppColors";
import Skeletons from "../skeleton-components/Skeletons";

const { width: screenWidth } = Dimensions.get("window");

const MyGamesStatusSkeleton: React.FC = () => {
  const deviceSize = useDeviceSize();
  const styles = useStyles();

  return (
    <View style={{ flex: 1 }}>
      <View
        style={{
          flex: 1,
          padding:
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? 12
              : 24,
          borderColor: AppColors.gray_828282,
          borderWidth: 0.8,
          borderRadius: 8,
          backgroundColor: AppColors.black_191919,
        }}
      >
        {/* Header */}
        <Skeletons
          width={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? "150px"
              : "200px"
          }
          height={24}
          style={{ borderRadius: 4 }}
        />

        {/* Separator */}
        <Skeletons
          width="100%"
          height={1}
          style={{ marginTop: 12, marginBottom: 12, borderRadius: 4 }}
        />

        {/* Progress Cards */}
        <View
          style={{
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-between",
            ...(deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? { gap: 12 }
              : {}),
          }}
        >
          {Array(5)
            .fill(null)
            .map((_, index) => (
              <View
                key={index}
                style={[
                  {
                    width:
                      deviceSize === DEVICE_SIZES.XS ||
                      deviceSize === DEVICE_SIZES.SM
                        ? "48%"
                        : "18%",
                    borderRadius: 10,
                    backgroundColor: AppColors.grayColor_282828,
                    alignItems: "center",
                    justifyContent: "center",
                    paddingVertical: 24,
                    paddingHorizontal: 16,
                  },
                  index === 4 &&
                  (deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM)
                    ? styles.fullWidthCard
                    : null,
                ]}
              >
                <Skeletons
                  width="94px"
                  height="94px"
                  circle
                  style={{ borderRadius: 47 }}
                />
                <Skeletons
                  width="80px"
                  height={14}
                  style={{ borderRadius: 4, marginTop: 18 }}
                />
              </View>
            ))}
        </View>
      </View>
    </View>
  );
};

export default MyGamesStatusSkeleton;

const useStyles = CreateResponsiveStyle(
  {
    fullWidthCard: {
      width: "100%",
    },
  },
  {
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.SM]: {},
    [DEVICE_SIZES.XS]: {},
  }
);
